import { watch, type Ref } from 'vue';

import { useWabunkaStateFactory } from '@/composables/utils/wabunka/useWabunkaStateFacroty';
import type { ReservationAccordionState } from '@/wabunka-src/common/features/Reservation/core/accordion/accordionState';
import { createDefaultReservationSectionGaEventState, planReservationSectionGaEvents } from '@/wabunka-src/common/features/Reservation/core/accordion/sectionGaEvents';
import { sendGAWabunkaReservationSectionCompleteEvent } from '@/wabunka-src/common/utils/googleAnalytics/events/reservationSectionComplete';
import { sendGAWabunkaReservationSectionViewEvent } from '@/wabunka-src/common/utils/googleAnalytics/events/reservationSectionView';

export const useReservationSectionGaEvents = (experienceId: () => string, accordionState: Readonly<Ref<ReservationAccordionState>>) => {
  const eventState = useWabunkaStateFactory('reservationSectionGaEventState', createDefaultReservationSectionGaEventState());

  watch(
    accordionState,
    (next, previous) => {
      const plan = planReservationSectionGaEvents(experienceId(), previous, next, eventState.value);
      eventState.value = plan.nextState;

      plan.completedEvents.forEach((completedEvent) => {
        sendGAWabunkaReservationSectionCompleteEvent(completedEvent.sectionId, completedEvent.isAutoCompleted);
      });
      if (plan.viewedSectionId) sendGAWabunkaReservationSectionViewEvent(plan.viewedSectionId);
    },
    { immediate: true },
  );
};
